import { useRequest } from 'features/request/useRequest';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { getCatalogGql } from '../catalogListQueries';

export const useCatalog = (catalogUniqueId = '') => {
    const dispatch = useDispatch();

    const variables = useMemo(
        () => ({
            catalogUniqueId,
        }),
        [catalogUniqueId],
    );

    const [catalogData, catalogStatus, , catalogRequest] = useRequest({
        requestId: 'catalog',
        query: getCatalogGql,
        variables,
        withEffect: Boolean(catalogUniqueId),
    });

    const getCatalog = useCallback(() => {
        dispatch(catalogRequest(variables));
    }, [catalogRequest, dispatch, variables]);

    return {
        catalogData: catalogData?.catalog,
        fetchingStatus: catalogStatus,
        getCatalog,
    };
};
